import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import Languages from './components/Languages';
import CTA from './components/CTA';
import WaitlistForm from './components/WaitlistForm';
import Footer from './components/Footer';

function App() {
  const [showWaitlistForm, setShowWaitlistForm] = useState(false);

  const openWaitlistForm = () => {
    setShowWaitlistForm(true);
  };

  const closeWaitlistForm = () => {
    setShowWaitlistForm(false);
  };

  return (
    <div className="App">
      {/* Animated Background */}
      <div className="bg-animation">
        <div className="floating-shape shape1"></div>
        <div className="floating-shape shape2"></div>
        <div className="floating-shape shape3"></div>
      </div>

      <Header onJoinWaitlist={openWaitlistForm} />
      <Hero onJoinWaitlist={openWaitlistForm} />
      <HowItWorks />
      <Features />
      <Languages />
      <CTA onJoinWaitlist={openWaitlistForm} />
      {showWaitlistForm && (
        <WaitlistForm isOpen={showWaitlistForm} onClose={closeWaitlistForm} />
      )}
      <Footer />
    </div>
  );
}

export default App;

